export default class LogConfig {
    enabled: boolean = true;
    level: string = 'debug';
}
